import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { post } from "../axios-post";
import { getFormmatedDate } from "../../helpers/et3-date-helper";

export const apiCallQAUpdateUserStatus = async ({
  userID,
  pageName,
  statusDate
}: {
  userID: number;
  pageName: string;
  statusDate: Date;
}): Promise<{
  data: number;
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<number>(
    `qa/qaChangeStatusDate`,
    {
      userID,
      pageName,
      statusDate: getFormmatedDate(statusDate)
    }
  );
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (
    status === "ERROR" &&
    isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      et3Error
    )
  ) {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: -1,
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: -1,
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  }
};
